import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["asset-manager"]
  static values = { folderId: String }

  #isHighlighted = false

  handleDragOver(event) {
    // Accept any drag (SortableJS or native)
    if (!this.hasAssetManagerOutlet) return

    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    if (!this.#isHighlighted) {
      this.#isHighlighted = true
      this.element.classList.add("bg-blue-50", "ring-2", "ring-blue-500", "ring-inset")
    }
  }

  handleDragLeave(event) {
    // Only clear if truly leaving
    if (this.element.contains(event.relatedTarget)) return

    this.#clearHighlight()
  }

  handleDrop(event) {
    event.preventDefault()
    event.stopPropagation()

    this.#clearHighlight()

    if (!this.hasAssetManagerOutlet) return

    // Get dragged asset IDs from asset-manager
    const assetIds = this.assetManagerOutlet.draggedIds
    if (!assetIds || assetIds.length === 0) {
      // Fallback: check if there's selection
      const selectedIds = this.assetManagerOutlet.selectedIds
      if (selectedIds.length > 0) {
        this.#moveToFolder(selectedIds)
      }
      return
    }

    this.#moveToFolder(assetIds)
  }

  setDropHighlight(highlighted) {
    if (highlighted) {
      this.element.classList.add("bg-blue-50", "ring-2", "ring-blue-500", "ring-inset")
    } else {
      this.#clearHighlight()
    }
  }

  #clearHighlight() {
    this.#isHighlighted = false
    this.element.classList.remove("bg-blue-50", "ring-2", "ring-blue-500", "ring-inset")
  }

  async #moveToFolder(assetIds) {
    if (!this.hasAssetManagerOutlet) return

    const projectId = this.assetManagerOutlet.projectIdValue
    const url = `/projects/${projectId}/assets/bulk_move`

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        },
        body: JSON.stringify({ asset_ids: assetIds, folder_id: this.folderIdValue })
      })

      if (response.ok) {
        Turbo.visit(window.location.href, { action: "replace" })
      } else {
        console.error("Move to folder failed:", await response.text())
      }
    } catch (error) {
      console.error("Move to folder error:", error)
    }
  }
}
